"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountClonedBlockPlaceholder = void 0;
var react_1 = __importDefault(require("react"));
var ClonedBlockPlaceholder_1 = require("./ClonedBlockPlaceholder");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var ClonedBlockPlaceholder = (function (_super) {
    __extends(ClonedBlockPlaceholder, _super);
    function ClonedBlockPlaceholder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayDelayActive = false;
        return _this;
    }
    ClonedBlockPlaceholder.prototype.componentDidMount = function () {
        var _this = this;
        (0, mobx_1.reaction)(function () { return _this.isOpen; }, function (isOpening) {
            if (!isOpening) {
                _this.displayDelayActive = false;
                clearTimeout(_this.timeoutId);
            }
            if (isOpening) {
                _this.displayDelayActive = true;
                _this.timeoutId = window.setTimeout(function () {
                    (0, mobx_1.runInAction)(function () {
                        _this.displayDelayActive = false;
                    });
                }, 750);
            }
        });
    };
    ClonedBlockPlaceholder.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeoutId);
    };
    ClonedBlockPlaceholder.prototype.render = function () {
        var isOpen = this.isOpen && !this.displayDelayActive;
        return react_1.default.createElement(ClonedBlockPlaceholder_1.ClonedBlockPlaceholderInner, { isOpen: isOpen });
    };
    Object.defineProperty(ClonedBlockPlaceholder.prototype, "isOpen", {
        get: function () {
            return this.props.blockList.isOperationInProgress({ type: "clone", clonedFromId: this.props.blockId });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ClonedBlockPlaceholder.prototype, "displayDelayActive", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ClonedBlockPlaceholder.prototype, "isOpen", null);
    ClonedBlockPlaceholder = __decorate([
        mobx_react_1.observer
    ], ClonedBlockPlaceholder);
    return ClonedBlockPlaceholder;
}(react_1.default.Component));
var mountClonedBlockPlaceholder = function (mountReactComponent) { return function (props) {
    return mountReactComponent(react_1.default.createElement(ClonedBlockPlaceholder, __assign({}, props)));
}; };
exports.mountClonedBlockPlaceholder = mountClonedBlockPlaceholder;
